import React, { useState, useEffect } from 'react';
import { BreadcrumbContext, getPageTypeFromBreadcrumbs } from './BreadcrumbContext';
import { BreadcrumbItem } from '../utils/breadcrumbsUtilService';
import { postMessageAction, postMessageService } from '../../shared/postMessageService';

export default function BreadcrumbContextProvider({ children }: { children: React.ReactNode }) {
    const [breadcrumbArray, setBreadcrumbArray] = useState<BreadcrumbItem[]>([]);

    useEffect(() => {
        // Send postMessage whenever breadcrumbArray changes
        if (breadcrumbArray.length > 0) {
            const pageType = getPageTypeFromBreadcrumbs(breadcrumbArray);

            postMessageService.sendToParent({
                action: postMessageAction.BREADCRUMB_CHANGED,
                pageType,
            });
        }
    }, [breadcrumbArray]);

    return (
        <BreadcrumbContext.Provider value={{ breadcrumbArray, setBreadcrumbArray }}>
            {children}
        </BreadcrumbContext.Provider>
    );
}
